import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  changeSuccessMsg: null,
  changeError: null,
  loading: false,
};

const changePasswordSlice = createSlice({
  name: "changePassword",
  initialState,
  reducers: {
    changePasswordStart(state) {
      state.loading = true;
      state.changeSuccessMsg = null;
      state.changeError = null;
    },
    changePasswordSuccess(state, action) {
      state.loading = false;
      state.changeSuccessMsg = action.payload;
    },
    changePasswordError(state, action) {
      state.loading = false;
      state.changeError = action.payload;
    },
  },
});

export const {
  changePasswordStart,
  changePasswordSuccess,
  changePasswordError,
} = changePasswordSlice.actions;

export default changePasswordSlice.reducer;
